var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import store from 'store';
import { get, isEmpty } from 'lodash';
import { Languages } from '../types/Languages';
import { MAINTENANCE_MODE_KEY, MAINTENANCE_SCHEDULED_KEY } from '../request/checkAppStatus';
import Oauth from '../providers/Auth0Provider/Auth0Provider';
import { getMaintenanceBannerKey } from '../helpers/utils';
import { checkTermsAccepted } from '../request/checkTermsAccepted';
import { validateEmail } from '../helpers/validateEmail';
import { ShareValues } from '../helpers/ShareValues';
import { THEMES, getPossibleTheme, themeKey } from '../types/Theme';
import { CentralProviderErrorTypes } from '../constants/centralProviderErrors';
import { useLocalStoreState } from '../hooks/useLocalStoreState';
import { runningOnCanvas } from '../utils/canvas';
var DEFAULT_THEMES = {
    on: THEMES.light,
    off: THEMES.dark,
};
var DEFAULT_THEME_NAMES_LIST = DEFAULT_THEMES.off !== undefined ? [DEFAULT_THEMES.off, DEFAULT_THEMES.on] : [DEFAULT_THEMES.on];
var CentralProviderContext = React.createContext({});
export var LegalDocsContext = React.createContext({});
function CentralProviderContextProvider(_a) {
    var _b = _a.themes, themes = _b === void 0 ? DEFAULT_THEMES : _b, children = _a.children;
    var _c = __read(useState(false), 2), termsChecked = _c[0], setTermsChecked = _c[1];
    var _d = __read(useState(), 2), centralProfile = _d[0], setCentralProfile = _d[1];
    var _e = __read(useState([]), 2), updatedLegalDocuments = _e[0], setUpdatedLegalDocuments = _e[1];
    var _f = __read(useState(false), 2), showLegalConsent = _f[0], setShowLegalConsent = _f[1];
    var _g = __read(useState(), 2), currentLanguage = _g[0], setCurrentLanguage = _g[1];
    var _h = __read(useState([Languages.EN_US]), 2), allowedLanguages = _h[0], setAllowedLanguages = _h[1];
    var _j = __read(useState(''), 2), application = _j[0], setApplication = _j[1];
    var _k = __read(useState(false), 2), translationsLoaded = _k[0], setTranslationLoaded = _k[1];
    var _l = __read(useState(false), 2), sessionExpired = _l[0], setSessionExpired = _l[1];
    var _m = __read(useState(false), 2), status = _m[0], setStatus = _m[1];
    var _o = __read(useState(false), 2), allowGrantLocationSelector = _o[0], setAllowGrantLocationSelector = _o[1];
    var _p = __read(useState(), 2), selectedGrant = _p[0], setSelectedGrant = _p[1];
    var _q = __read(useState(), 2), selectedGrantLocation = _q[0], setSelectedGrantLocation = _q[1];
    var _r = __read(useState(false), 2), selectingGrant = _r[0], setSelectingGrantInternal = _r[1];
    var _s = __read(useState(false), 2), showGlobalSearch = _s[0], setShowGlobalSearch = _s[1];
    var _t = __read(useState(), 2), displayError = _t[0], setError = _t[1];
    var _u = __read(useState(false), 2), allowThemeSwitcher = _u[0], setAllowThemeSwitcher = _u[1];
    var _v = __read(useLocalStoreState(store, themeKey, getPossibleTheme(store, themeKey, DEFAULT_THEME_NAMES_LIST, DEFAULT_THEMES === null || DEFAULT_THEMES === void 0 ? void 0 : DEFAULT_THEMES.on)), 2), currentTheme = _v[0], setCurrentTheme = _v[1];
    var _w = __read(useState(false), 2), disableNotifications = _w[0], setDisableNotifications = _w[1];
    var _x = __read(useState(false), 2), disableTranslationsManager = _x[0], setDisableTranslationsManager = _x[1];
    var _y = __read(useState(false), 2), validateProfileFields = _y[0], setValidateProfileFields = _y[1];
    var _z = __read(useState(), 2), sidebarRef = _z[0], setSidebarRef = _z[1];
    var _0 = __read(useState(false), 2), useMdmId = _0[0], setUseMdmId = _0[1];
    var _1 = __read(useState(null), 2), scheduledMaintenance = _1[0], setScheduledMaintenance = _1[1];
    var _2 = __read(useState(), 2), onGrantLocationSelection = _2[0], setOnGrantLocationSelection = _2[1];
    var _3 = __read(useState(), 2), onThemeChange = _3[0], setOnThemeChange = _3[1];
    var _4 = __read(useState(false), 2), showLegalDocs = _4[0], setShowLegalDocs = _4[1];
    useEffect(function () {
        if (!allowThemeSwitcher) {
            setCurrentTheme(themes.on);
        }
    }, []);
    var checkProfileFields = function () {
        if (!validateEmail(centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.email)) {
            return true;
        }
        if ((centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.profile.profile_type) !== 'business'
            && (isEmpty(centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.profile.first_name)
                || isEmpty(centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.profile.last_name))) {
            return true;
        }
        if ((centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.profile.profile_type) === 'business'
            && isEmpty(centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.profile.company_name)) {
            return true;
        }
        return false;
    };
    var logout = function () {
        Oauth.logout();
    };
    var hasFullAccountAccess = function (accountTypes) {
        if (!centralProfile || !centralProfile.grants)
            return false;
        return centralProfile.grants.some(function (g) {
            var amp = get(g, 'role.permissions.accounts_manager');
            if (amp) {
                switch (accountTypes) {
                    case 'fleets': return Boolean(amp.manage_all_fleets);
                    case 'providers': return Boolean(amp.manage_all_providers);
                    case 'any': return Boolean(amp.manage_all_fleets || amp.manage_all_providers);
                    case 'both': return Boolean(amp.manage_all_fleets && amp.manage_all_providers);
                    default: return false;
                }
            }
            else {
                // The else section needs to be deprecated soon
                // (once every app has accounts_manager on it's role definition)
                if (g.role.name.toLocaleLowerCase() === 'michelin employee')
                    return true;
                if (g.role.name.toLocaleLowerCase() === 'michelin administrator')
                    return true;
                if (g.role.name.toLocaleLowerCase() === 'dsp central administrator')
                    return true;
            }
            return false;
        });
    };
    useEffect(function () {
        ShareValues.updateInstance(__assign(__assign({}, ShareValues.getData()), { selectedGrant: selectedGrant, centralProfile: centralProfile, application: application }));
    }, [selectedGrant, centralProfile, application]);
    useEffect(function () {
        var accessToken = ShareValues.getAuthResultTokenAccess();
        if (centralProfile && accessToken) {
            if (!showLegalDocs || runningOnCanvas()) {
                // Not showing terms and condition when running the application on Canvas (from salesforce) or app is not urban order
                setTermsChecked(true);
            }
            else {
                checkTermsAccepted(accessToken, application).then(function (termsData) {
                    var _a;
                    setShowLegalConsent(termsData
                        ? !termsData.terms_accepted || ((_a = termsData.updated_documents) === null || _a === void 0 ? void 0 : _a.length) > 0
                        : false);
                    setUpdatedLegalDocuments(termsData ? termsData.updated_documents : []);
                    setTermsChecked(true);
                });
            }
            setValidateProfileFields(checkProfileFields());
        }
    }, [centralProfile, showLegalDocs]);
    useEffect(function () {
        if (onThemeChange)
            onThemeChange(currentTheme);
    }, [currentTheme, onThemeChange]);
    var checkScheduledMaintenance = function (appKey, scheduledMaintenanceSetting) {
        if (!scheduledMaintenanceSetting) {
            return null;
        }
        var lsKey = getMaintenanceBannerKey(appKey);
        var showBannerAgainDate = localStorage.getItem(lsKey);
        // If we should show again the banner, we check if the maintenance is still scheduled.
        if (!showBannerAgainDate || parseInt(showBannerAgainDate) < Math.floor(Date.now() / 1000)) {
            localStorage.removeItem(lsKey);
            return scheduledMaintenanceSetting;
        }
        return null;
    };
    var setAppStatus = function (response, appKey) {
        var maintenanceMode = response ? response[MAINTENANCE_MODE_KEY] : null;
        var online = !(maintenanceMode === null || maintenanceMode === void 0 ? void 0 : maintenanceMode.value);
        var scheduledMaintenanceSetting = online
            ? checkScheduledMaintenance(appKey, response ? response[MAINTENANCE_SCHEDULED_KEY] : null)
            : null;
        setStatus(online);
        if (!online) {
            setError({
                key: CentralProviderErrorTypes.APP_OFFLINE,
                props: {
                    messageEn: maintenanceMode === null || maintenanceMode === void 0 ? void 0 : maintenanceMode.messageEn,
                    messageFr: maintenanceMode === null || maintenanceMode === void 0 ? void 0 : maintenanceMode.messageFr,
                    application: maintenanceMode === null || maintenanceMode === void 0 ? void 0 : maintenanceMode.appName,
                },
            });
        }
        setScheduledMaintenance(scheduledMaintenanceSetting);
        return online;
    };
    var setCurrentGrant = function (grant) {
        var location = get(grant, 'accounts.0');
        if (onGrantLocationSelection)
            onGrantLocationSelection(grant, location);
        setTimeout(function () {
            setSelectedGrant(grant);
            setSelectedGrantLocation(location);
        }, 0);
    };
    var setSelectingGrant = function (selected) {
        if (selected === selectingGrant)
            return;
        setTimeout(function () { return setSelectingGrantInternal(selected); }, 0);
    };
    return (React.createElement(LegalDocsContext.Provider, { value: {
            showLegalDocs: function (check) { return setShowLegalDocs(check); }
        } },
        React.createElement(CentralProviderContext.Provider, { value: {
                termsChecked: termsChecked,
                centralProfile: centralProfile,
                setCentralProfile: setCentralProfile,
                updatedLegalDocuments: updatedLegalDocuments,
                showLegalConsent: showLegalConsent,
                currentLanguage: currentLanguage,
                allowedLanguages: allowedLanguages,
                setCurrentLanguage: setCurrentLanguage,
                setAppStatus: setAppStatus,
                application: application,
                setTranslationLoaded: setTranslationLoaded,
                translationsLoaded: translationsLoaded,
                logout: logout,
                sessionExpired: sessionExpired,
                status: status,
                setSessionExpired: setSessionExpired,
                allowGrantLocationSelector: allowGrantLocationSelector,
                setCurrentGrant: setCurrentGrant,
                selectedGrant: selectedGrant,
                selectedGrantLocation: selectedGrantLocation,
                selectingGrant: selectingGrant,
                setSelectingGrant: setSelectingGrant,
                showGlobalSearch: showGlobalSearch,
                setError: setError,
                displayError: displayError,
                allowThemeSwitcher: allowThemeSwitcher,
                currentTheme: currentTheme,
                setCurrentTheme: setCurrentTheme,
                disableNotifications: disableNotifications,
                disableTranslationsManager: disableTranslationsManager,
                hasFullAccountAccess: hasFullAccountAccess,
                validateProfileFields: validateProfileFields,
                sidebarRef: sidebarRef,
                setSidebarRef: setSidebarRef,
                useMdmId: useMdmId,
                scheduledMaintenance: scheduledMaintenance,
                setApplication: setApplication,
                setAllowedLanguages: setAllowedLanguages,
                setAllowGrantLocationSelector: setAllowGrantLocationSelector,
                setUseMdmId: setUseMdmId,
                setShowGlobalSearch: setShowGlobalSearch,
                setAllowThemeSwitcher: setAllowThemeSwitcher,
                setDisableNotifications: setDisableNotifications,
                setDisableTranslationsManager: setDisableTranslationsManager,
                setOnGrantLocationSelection: setOnGrantLocationSelection,
                setOnThemeChange: setOnThemeChange,
                setShowLegalConsent: setShowLegalConsent,
                setValidateProfileFields: setValidateProfileFields,
                themes: themes,
            } }, children)));
}
export { CentralProviderContextProvider, CentralProviderContext };
//# sourceMappingURL=CentralProviderContext.js.map